export const formatDateForTeamsTable = (date: Date) => {
  const dateObj = new Date(date)
  const month = dateObj.toLocaleString('default', { month: 'short' })
  const day = dateObj.getDate()
  const year = dateObj.getFullYear()

  let daySuffix
  if (day === 1 || day === 21 || day === 31) {
    daySuffix = 'st'
  } else if (day === 2 || day === 22) {
    daySuffix = 'nd'
  } else if (day === 3 || day === 23) {
    daySuffix = 'rd'
  } else {
    daySuffix = 'th'
  }
  return `${month}. ${day}${daySuffix}, ${year}`
}

export const isDateOver30DaysOld = (date: Date) =>
  new Date(date) < new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
